module.exports = __webpack_public_path__ + "img/image-droite.846cac77.jpg";